import { render, staticRenderFns } from "./TrendlineDashboard.vue?vue&type=template&id=58e3a940&"
import script from "./TrendlineDashboard.vue?vue&type=script&lang=js&"
export * from "./TrendlineDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TrendlineDashboard.vue?vue&type=style&index=0&id=58e3a940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports